import{buildGlobalCssWithSectionStyleGenerators as e}from"../../utils/build-global-css/build-global-css.js";import{buildCssMobile as t}from"./build-css-mobile.js";function n(e){return`
    @media all and (max-width: ${e||`480px`}) {
      .visibility-desktop-only {
        display: none!important;
      }
    }
    @media all and (min-width: ${parseInt(e||`480px`,10)+1}px) {
      .visibility-mobile-only {
        display: none!important;
      }
    }
  `}function r({css:r,breakPoint:i,composerData:a,experiments:o,sections:s,buildForMobile:c}){return[`.so-link-href {text-decoration: none;}
    `,n(i).trim(),c?t(r).trim():``,e({breakPoint:i,composerData:a,css:r,experiments:o,sections:s,buildForMobile:c}).trim()].join(``)}export{r as buildCss};
//# sourceMappingURL=build-css.js.map